import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ApiResult, IInstitution, ILookup } from 'src/app/shared/model/Index';
import { map } from 'rxjs/operators';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { SharedService } from '../../services/shared.service';
import { Messages } from '@app/modules/compliance/constants/messages';


@Component({
    selector: 'app-institutionsearch',
    templateUrl: './institution-search.component.html',
    styleUrls: ['./institution-search.component.css'],
})
// Not using this Dialog but kept it for reference.
export class InstitutionSearchDialog implements OnInit {
    // public lookup: ILookup;
    //public tableName: string;
    private isHighSchool: boolean;
    public searchText: any;
    public title: string = "Institution Search";
    displayedColumns: string[] = ['code', 'ncaacode', 'description', 'countryCode', 'stateCode'];
    dataSource = new MatTableDataSource<IInstitution>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    constructor(
        public dialogRef: MatDialogRef<InstitutionSearchDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _snackBar: MatSnackBar, private _sharedservice: SharedService) { }
    ngOnInit() {
        // this.lookup = this.data.lookup;
        this.searchText = this.data.searchText;
        this.isHighSchool = this.data.isHighSchool;
        this.title = this.data.title;
        if (this.searchText) {
            this.searchInstitution();
        }
        else {
            this.searchText = "";
        }
        if (!this.isHighSchool) {
            this.displayedColumns.push('isJuniorCollege');
        }
    }
    cancel() {
        this.dialogRef.close();
    }

    public searchInstitution() {
        this._sharedservice.instituteSearch(this.searchText, this.isHighSchool).subscribe((result: ApiResult<IInstitution[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<IInstitution>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
    getRecord(row: any) {
        this.dialogRef.close(row);
    }
    notify() {
        let snackBarRef = this._snackBar.open(Messages.LookupSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
}